import { Grid } from '@material-ui/core';
import { ModalWithButtons } from '../../components/ModalWithButtons/ModalWithButtons.component';
import { ExaminerTreemapPanel } from './ExaminerTreemapPanel.component';
import { DataForExaminerTreeMap } from '../Dashboard/Dashboard.types';

interface ExaminerTreemapModalProps {
  data: DataForExaminerTreeMap;
  examinerMode?: boolean;
  onClose: () => void;
}

export const ExaminerTreemapModal: React.FC<ExaminerTreemapModalProps> = ({ onClose, data, examinerMode }) => {
  const modalStyle = {
    width: '90%',
    height: '90%',
    left: '5%',
    top: '5%',
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={onClose}
        open={true}
        title={' '}
        fullScreen
        isPageInModal
        pageContainerStyle={modalStyle}
        isHideBackdrop={false}
      >
        <Grid>
          <Grid item xs={12}>
            <ExaminerTreemapPanel
              sheetId={data.sheetId}
              assessmentSessionName={data.assessmentSessionName}
              subject={data.subject}
              isExamSheetConfigured={data.isExamSheetConfigured}
              isControlProcessActive={data.isControlProcessActive}
              examinerMode={examinerMode}
            />
          </Grid>
        </Grid>
      </ModalWithButtons>
    </>
  );
};
